import React from 'react';
import classnames from 'classnames';
import { Button } from '../Button/Button';
import { IDropShadow } from '../types/dropShadow';
import {
  getShadowClassNames,
  getZIndexClassNames,
} from '../utils/component-library-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';

interface INavBarProps extends IDropShadow {
  backBtn?: boolean;
  className?: string;
  padding?: '1' | '2' | '3' | '4';
  title?: React.ReactNode;
  titleClassName?: string;
  rightContent?: React.ReactNode;
  sticky?: boolean;
  zIndex?: '10' | '20' | '30' | '40' | '50';
  onBack?: (e?: any) => void;
  backBtnText?: string;
  /** Merged onto the back `Button` (e.g. circular gray hit target). */
  backBtnClassName?: string;
}

export const NavBar: React.FC<React.PropsWithChildren<INavBarProps>> = ({
  className,
  backBtn,
  padding = '3',
  shadow,
  title,
  titleClassName = '',
  rightContent,
  sticky,
  zIndex,
  onBack,
  backBtnText,
  backBtnClassName,
}) => {
  const hasTitle = !!title;

  return (
    <nav
      className={classnames(
        'items-center',
        hasTitle ? 'grid grid-cols-[auto_minmax(0,1fr)_auto] gap-1' : 'flex',
        className,
        backBtn,
        `p-${padding}`,
        getShadowClassNames(shadow),
        { 'sticky top-0 left-0': sticky },
        getZIndexClassNames(zIndex)
      )}
    >
      <div className="flex min-w-0 justify-start">
        {backBtn && (
          <Button
            clear
            className={classnames('-mx-3', backBtnClassName)}
            onClick={onBack}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
            {!!backBtnText && (
              <span className="inline-block ml-2">{backBtnText}</span>
            )}
          </Button>
        )}
      </div>
      {hasTitle && (
        <div
          className={classnames(
            'min-w-0 truncate px-3 text-center',
            titleClassName
          )}
        >
          {title}
        </div>
      )}
      <div
        className={classnames(
          'flex min-w-0 justify-end',
          !hasTitle && 'ml-auto'
        )}
      >
        {rightContent}
      </div>
    </nav>
  );
};
